module.exports = __webpack_public_path__ + "media/images/emblems/Eriswil-coat_of_arms-3b5d2c2ce0adbab1cb639dda3f112fa7.svg";